import TopicTwo from "../../resource-contents/economic-calendar-contents/TopicTwo";

const EconomicCalendarContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__resource">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Precision Meets Preparation</h1>
            <p>
              Plan your trades around reliable global economic data, not
              speculation.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Global Coverage</h4>
                </div>
                <p>
                  Track key events from all major economies and emerging
                  markets.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>User-Friendly Interface</h4>
                </div>
                <p>
                  Navigate effortlessly through filters by country, category, or
                  impact.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Comprehensive Analysis</h4>
                </div>
                <p>
                  Access expert insights on how each event could influence
                  market direction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EconomicCalendarContentFive;
